export { default as PostIcon } from './component';
